import React, { useState, useReducer, useRef, useEffect, useImperativeHandle, forwardRef } from "react";
import CustomDropDown from "../CustomDropDown/CustomDropDown";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import classes from './MassAddUserForm.module.css'
import ToggleInput from "../UI/ToggleInput";
import Input from "../CustomDropDown/Input/Input";
import Button1 from "../UI/Button/Button1";
import { inviteUser, UserPowerSearch } from "../../Api Methods/Api";
import { ListBox } from "primereact/listbox";
import { Button } from "primereact/button";
import { DataView } from "primereact/dataview";
import { classNames } from "primereact/utils";
import { Tag } from "primereact/tag";
import Button2 from "../UI/Button/Button2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import Papa from 'papaparse';
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { ToggleButton } from "primereact/togglebutton";
import { SelectButton } from "primereact/selectbutton";
import Modal from '../Modal/Modal'
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'

import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";

import downloadIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/download.png'



const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const emailReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: emailRegex.test(action.val) };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}

// Reducer function
const userRoleReducer = (state, action) => {

    if (action.type === 'TOGGLE_DROPDOWN') {
        return { ...state, showDropDownOptions: !state.showDropDownOptions, isValid: null };
    }

    if (action.type === 'SELECT_OPTION') {
        return { ...state, selectedOption: action.payload, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'BLUR_DROPDOWN') {
        return { ...state, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { selectedOption: null, isValid: null };
    }
    //otherwise 
    return { state };
};


const MassAddUserForm = ({ apiData, sites, userID, HandleDeviceUserList, companyName, showAddingUsersModal, setModalMessageSuccess, setModalMessageFail, successVisible, setSuccessVisible, setIsCompleteModalOpen, currentSitePosition, setCurrentSitePosition, currentUserPosition, setCurrentUserPosition, totalUsers, setTotalUsers, liveViewEnabled }, props) => {

    console.log(sites);
    const [formIsValid, setFormIsValid] = useState(false);
    const [emailState, dispatchEmail] = useReducer(emailReducer, {
        value: '',
        isValid: null
    });

    // UserRole Drop Down reducer  ----------------
    const [userRoleState, dispatchUserRole] = useReducer(userRoleReducer, {
        showDropDownOptions: false,
        selectedOption: '', // Initial selectedOption state
        isValid: null
    });

    const { showDropDownOptions: showUserRoleDropDownOptions, selectedOption: selectedUserRoleOption } = userRoleState;

    const [usersToAdd, setUsersToAdd] = useState([])
    const [role, setRole] = useState("User")

    const emailInputRef = useRef();
    const userRoleDropdownRef = useRef();

    const { isValid: emailIsValid } = emailState;
    const { isValid: userRoleIsValid } = userRoleState;

    const [userSuggestions, setUserSuggestions] = useState([]);
    const [stopSearch, setStopSearch] = useState(false)

    const [rowClick, setRowClick] = useState(true);

    setModalMessageSuccess("")
    setModalMessageFail("")

    const [isUsersToAddOpen, setIsUsersToAddOpen] = useState(false)

    const ModalDialog = useRef();
    const [modalTitle, setModalTitle] = useState("Users to add")
    const [modalComponent, setModalComponent] = useState()
    const [rerender, setRerender] = useState(false)


    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }

    useEffect(() => {
        const identifier = setTimeout(() => {
            setFormIsValid(emailIsValid && userRoleIsValid);
        }, 500);

        return () => {
            clearTimeout(identifier);
        };
    }, [emailIsValid, userRoleIsValid, emailState.value]);

    useEffect(() => {
        setStopSearch(false)
        const searchUser = async () => {
        const body = {
                "query": emailState.value || "",
                "portalAdmin": 0,
                "appAdmin": 0,
                "pageSize": 20,
                "pageOffset": 0
            }
        
            const users = await UserPowerSearch(apiData, body, dispatch);
            const userEmailAddresses = users[0].users.map(user => ({
                email: user.email,
                name: user.fullName
            }));
            setUserSuggestions(userEmailAddresses)
        }

        const delayDebounceFn = setTimeout(() => {
            if (emailState.value !== '' && !stopSearch) {
                searchUser()
            } else {
                setUserSuggestions([])
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);

    }, [emailState.value])

    const emailChangeHandler = (event) => {
        dispatchEmail({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const validateEmailHandler = () => {
        dispatchEmail({ type: 'INPUT_BLUR' });
    }

    // Drop down handlers ---------------
    const handleUserRoleDropDownOnClick = () => {
        dispatchUserRole({ type: 'TOGGLE_DROPDOWN' });
    };

    const handleUserRoleOptionChange = (option) => {
        dispatchUserRole({ type: 'SELECT_OPTION', payload: option });
    };
    const handleUserRoleBlur = () => {
        dispatchUserRole({ type: 'BLUR_DROPDOWN' });
    };

    const onClearHandler = () => {
        dispatchEmail({ type: 'INPUT_CLEAR', val: "" })
        dispatchUserRole({ type: 'INPUT_CLEAR', val: "" })
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [startDateTime, setStartDateTime] = useState('')
    const [endDateTime, setEndDateTime] = useState('')
    const [isTemp, setIsTemp] = useState(false)
    const [appAdmin, setAppAdmin] = useState(false)

    let userPosition = 0

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const inviteToSelectedSites = async () => {
        showAddingUsersModal();
        setModalMessageSuccess("Adding users...");
        setModalMessageFail("");

        const successUsers = new Set();
        const failedUsers = new Set();
        let liveViewAccess = 0
        let localRole = ""
        setTotalUsers(usersToAdd.length)

        console.log(usersToAdd);
        console.log(sites);

        for (const site of sites) {
            setCurrentSitePosition(currentSitePosition++)
            userPosition = 0
            setCurrentUserPosition(userPosition)
            const deviceID = site.id;
            const deviceName = site.tag && site.tag.trim() != "" ? site.tag : site.key;

            


            for (const user of usersToAdd) {
                localRole = role
                if (role == "Manager plus"){
                    localRole = "Manager"
                    liveViewAccess = 1
                }
                try {
                    const responseData =
                    await inviteUser(
                            apiData,
                            deviceID,
                            userID,
                            localRole,
                            user.email,
                            deviceName,
                            companyName,
                            appAdmin == true ? 1 : 0,
                            liveViewAccess,
                            dispatch
                        );

                        console.log(responseData);

                    if (responseData) {
                        successUsers.add(user.email);
                        setModalMessageSuccess(
                            `Added ${user.email} `
                        );
                        
                    } else {
                        failedUsers.add(user.email);
                        setModalMessageFail(
                            Array.from(failedUsers).map(email => `Failed to add ${email} ❌`).join('\n')
                        );
                    }
                    userPosition++
                    setCurrentUserPosition(userPosition)
                }
                catch (err) {
                    console.error(`Error inviting ${user.email} to site ${deviceName}:`, err);
                    failedUsers.add(user.email);
                }
                
                await delay(500);
            }
        }

        setIsCompleteModalOpen(false)
        setSuccessVisible(true)
        setTotalUsers(0)
        setCurrentSitePosition(1)
        setCurrentUserPosition(1)
    };


    const submitHandler = (event) => {
        event.preventDefault();
        inviteToSelectedSites();
    };

    const removeUser = (email) => {
        setUsersToAdd(usersToAdd.filter(user => user.email !== email));
        HandleCloseModal();
        setRerender(true)
    };

    useEffect(() => {
        if (rerender) {
            showUsersToAdd();
            setRerender(false)
        }
    }, [rerender])

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                if (!results.meta.fields?.includes("Email address")) {
                    alert("Invalid file format. The CSV must contain an 'Email address' column.");
                    return;
                }

                const parsedEmails = results.data
                    .map(row => row["Email address"])
                    .filter(email => typeof email === "string" && email.trim() !== "")
                    .map(email => email.trim());

                for (const email of parsedEmails) {
                    const userObj = {
                        email,
                        role: "User"
                    };

                    setUsersToAdd(prevUsersToAdd => [
                        ...prevUsersToAdd,
                        userObj
                    ]);
                }
            }
        });
    };

    const roleOptions = liveViewEnabled == 1 ? [
        "Manager",
        "Manager plus",
        "User"
    ] : 
    [
        "Manager",
        "User"
    ]

    const setSelectedUsers = (user) => {
        for (const userObj of user) {
            let userToAdd = {
                name: userObj.name,
                email: userObj.email,
                role: role
            }
            setUsersToAdd((prevUsersToAdd) => {
                return [...prevUsersToAdd, userToAdd];
            });
        }

        const selectedEmails = user.map(u => u.email);
        const newSuggestions = userSuggestions.filter(
            suggestedUser => !selectedEmails.includes(suggestedUser.email)
        );

        setUserSuggestions(newSuggestions);
    }

    const UsersToAddModal = ({ usersToAdd, onClose }) => (
        <div className={classes.smallTableWrapper} style={{ maxHeight: '500px', overflowY: 'auto', marginBottom: "10px" }}>            
        <DataTable value={usersToAdd} stripedRows tableStyle={{ minWidth: '30rem' }}>
            <Column field="name" header="Name" />
            <Column field="email" header="Email Address" />
            <Column field="role" header="Role" />
            <Column
                body={(rowData) => (
                    <Button
                        icon="pi pi-times"
                        className="p-button-rounded p-button-text p-button-danger p-0"
                        style={{ height: '1rem', width: '1rem' }}
                        onClick={() => removeUser(rowData.email)}
                        aria-label="Revoke access"
                    />
                )}
                style={{ width: '3rem', textAlign: 'center' }}
            />
        </DataTable>
        </div>
    );

    const showUsersToAdd = () => {
        setModalComponent(
            <UsersToAddModal
                usersToAdd={usersToAdd}
                onClose={HandleCloseModal}
            />
        );
        HandleShowModal();
    };

    const handleRole = (value) => {
        setRole(value)
    }

    return (
        <>
            <Modal ref={ModalDialog} title={modalTitle} modalName={"UsersToAdd"} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

            <form onSubmit={submitHandler} className={classes["container"]} method="dialog" >
                <p style={{ fontWeight: "600", fontSize: "18px", color: "#6e6e6e", margin: "4px 0" }}>
                    Please note, the search feature is only available for existing users</p>
                <p style={{ fontWeight: "500", fontSize: "16px", color: "#6e6e6e", margin: "4px 0", textAlign: "center" }}>
                    Search for an existing user by name or email. As you type, matching users will be suggested automatically.</p>
                <p style={{ fontWeight: "500", fontSize: "16px", color: "#6e6e6e", margin: "4px 0" }}>
                    Press 'View users to add' to view or edit the selected users</p>
                    <br/>
                    <SelectButton value={role} onChange={(e) => handleRole(e.value)} options={roleOptions} />
                    <br/>
                <li className={classes["input-container"]}>
                    <InputText
                        style={{ width: "400px" }}
                        placeholder={"Search users..."}
                        ref={emailInputRef}
                        id="Email"
                        type={"text"}
                        isValid={emailState.isValid}
                        value={emailState.value}
                        onChange={emailChangeHandler}
                        onBlur={validateEmailHandler}
                        autoComplete="off"
                    />
                </li>
                {userSuggestions.length > 0 && (
                    <div style={{ maxHeight: '400px', overflowY: 'auto', marginTop: '0px' }}>
                        <DataTable
                            value={userSuggestions}
                            selectionMode={rowClick ? null : 'checkbox'}
                            onSelectionChange={(e) => setSelectedUsers(e.value)}>
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                            <Column field="name"></Column>
                            <Column field="email"></Column>
                        </DataTable>
                    </div>
                )}
                <br/>
                <div className={classes["checkbox-container"]} style={{marginBottom:"10px"}}>
                    <Checkbox onChange={e => setIsTemp(!isTemp)} checked={isTemp} name='Temporary access?'></Checkbox>
                    <label className="ml-2">   {"Temporary access (applies to ALL selected users)"}</label>
                </div>

                {/* <div className={classes["checkbox-container"]}>
                    <Checkbox onChange={e => setAppAdmin(!appAdmin)} checked={appAdmin} name='App admin?'></Checkbox>
                    <label className="ml-2">   {"Enable app admin (applies to ALL selected users)"}</label>
                </div> */}
                {isTemp && 
                    <div className={classes["dateTime-container"]}>
                        {/* <p>From: </p>
                        <Calendar value={startDateTime} onChange={(e) => setStartDateTime(e.value)} showTime hourFormat="24" dateFormat="dd/mm/yy" /> */}
                        <p>Until: </p>
                        <Calendar value={endDateTime} onChange={(e) => setEndDateTime(e.value)} showTime hourFormat="24" dateFormat="dd/mm/yy" />
                    </div>
                }
                <Divider type='solid'/>
                <p style={{ fontWeight: "600", fontSize: "18px", color: "#6e6e6e", margin: "4px 0" }}>
                    Or you can upload a .csv file of email addresses below</p>

                <div style={{display:"flex", flexDirection:"row"}}>
                    <img src={downloadIcon} style={{width:"20px", height:"20px", marginRight:"10px"}}/>
                    <p style={{ fontWeight: "500", fontSize: "16px", color: "#6e6e6e", margin: "4px 0" }}>
                                    Please use the{" "}
                                        <a
                                            href="/Invite_users_template.csv"
                                            download
                                            style={{ color: "#007bff", textDecoration: "underline" }}
                                        >
                                            provided template
                                        </a>{" "}
                                    to ensure invites are sent correctly
                                </p>
                </div>
              

                
                <br></br>
                <div>
                    <input type="file" accept=".csv" onChange={handleFileUpload} />
                </div>
                <br></br>
                <p style={{ fontWeight: "400", fontSize: "16px", color: "#6e6e6e", margin: "4px 0", fontStyle:"italic" }}>
                    Existing users will be automatically added to the sites, new users will be sent an invite</p>
                   
                 <Divider type='solid'/>
               

                <div className={classes["button-container"]}>
                    <Button
                        severity="secondary"
                        type="button"
                        onClick={showUsersToAdd}
                        icon="pi pi-eye" 
                    >
                        {`View users to add (${usersToAdd.length})`}
                    </Button>

                    <Button icon="pi pi-check"  severity="success" type="submit">
                        Finish
                    </Button>
                </div>
            </form>
        </>

    )


}

export default MassAddUserForm;

